module.exports = __webpack_public_path__ + "assets/img/jd2.6db82bb5.jpg";